// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Uh7WZ","job":"Home_job__1-Q3Z","socials":"Home_socials__wEVVm","social":"Home_social__vz1j9"};